module.exports = __webpack_public_path__ + "img/sidelogo.91237b95.png";